export default "__VITE_ASSET__nqnEb92Q__"